import { Box, Skeleton } from "@mui/material";
import { COPY_ISIN_MODAL_LOADING_STATE_TEST_ID } from "./tests/copy-isin-dialog.test-ids";

export const CopyIsinSkeleton = () => (
    <>
        <Box data-test-id={COPY_ISIN_MODAL_LOADING_STATE_TEST_ID} />

        <Box component="header">
            <Box sx={{ gap: 2 }} display="flex" flexDirection="column">
                <Skeleton variant="rectangular" height={"32px"} width="80%" />
                <Skeleton variant="rectangular" height={"32px"} width="60%" />
            </Box>
        </Box>

        <Box component="section" pt={3}>
            <Box sx={{ gap: 2 }} display="flex" flexDirection="column">
                <Skeleton variant="rectangular" height={"32px"} width="80%" />
                <Skeleton variant="rectangular" height={"32px"} width="40%" />
            </Box>
        </Box>

        <Box component="footer" sx={{ mt: { xs: "auto", sm: undefined }, pt: 5 }}>
            <Skeleton variant="rectangular" height={"32px"} width="30%" />
        </Box>
    </>
);
